import { Navigation } from "lucide-react";
import useCurrentUserGeoLocation from "../../../hooks/useCurrentUserGeoLocation";
import ToolbarButton from "../../../components/SearchListings/ToolbarButton";
import { GeoLocation } from "../../../types/common";

const MyLocationToolbarButton = ({ onClick, className }: { onClick(geoLocation: GeoLocation): void; className?: string }) => {
    const {
        isLoading: isLoadingCurrentUserGeoLocation,
        refetch: getCurrentUserGeoLocation,
    } = useCurrentUserGeoLocation();

    return <ToolbarButton
        icon={<Navigation className="h-4 w-4" />}
        isLoading={isLoadingCurrentUserGeoLocation}
        className={className}
        onClick={async () => {
            const { data: currentUserGeoLocation } =
                await getCurrentUserGeoLocation();
            if (currentUserGeoLocation) {
                onClick(currentUserGeoLocation as GeoLocation)
            }
        }}
    />

}

export default MyLocationToolbarButton;